import Vue from 'vue';

Vue.directive('focus-list', {
  inserted: (el) => {
    el.focus();
    const firstListItem: any = el.children[0];
    if (!firstListItem) return;
    firstListItem.focus();
  },
});
